module.exports = __webpack_public_path__ + "static/media/figure-seven.e01995a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/figure-seven.png
// module id = 542
// module chunks = 0